import { apiClient } from './client';
import type { ApiResponse, PagedResult } from '@/types/api.types';
import type {
  CurrencyDto,
  CurrencyListDto,
  CurrencyFilterDto,
  CreateCurrencyRequest,
  UpdateCurrencyRequest,
} from '@/types/currency.types';

export const currencyApi = {
  /** GET /api/v1/currencies — paginated list with optional search/filter */
  getList: (filter?: CurrencyFilterDto) =>
    apiClient.get<ApiResponse<PagedResult<CurrencyListDto>>>('/currencies', {
      params: filter,
    }),

  /** GET /api/v1/currencies/{id} — full currency record */
  getById: (id: string) =>
    apiClient.get<ApiResponse<CurrencyDto>>(`/currencies/${id}`),

  /** GET /api/v1/currencies/by-code/{code} — returns 404 when not found */
  getByCode: (code: string) =>
    apiClient.get<ApiResponse<CurrencyDto>>(
      `/currencies/by-code/${encodeURIComponent(code)}`,
    ),

  /** POST /api/v1/currencies — create a new currency */
  create: (data: CreateCurrencyRequest) =>
    apiClient.post<ApiResponse<{ id: string }>>('/currencies', data),

  /** PUT /api/v1/currencies/{id} — update currency details */
  update: (id: string, data: UpdateCurrencyRequest) =>
    apiClient.put<ApiResponse<object>>(`/currencies/${id}`, data),

  /** DELETE /api/v1/currencies/{id} — soft-delete the currency */
  remove: (id: string) =>
    apiClient.delete<ApiResponse<object>>(`/currencies/${id}`),
};
